// extracted by mini-css-extract-plugin
export default {"p":"ffd633207a a12013f425 _28c77ca7a8","clr":"_0c610ccbad","dls":"_2a9b807cf1"};